// Module-level audio singleton. Scenes import this rather than each
// constructing their own AudioManager — it's per-page state anyway and
// keeps the AudioContext as a single shared resource.

import { AudioManager } from './manager';

export const audio = new AudioManager();

export { AudioManager } from './manager';
export type { SfxName } from './manager';
